export const GET_CHARACTERS = 'GET_CHARACTERS';
export const GET_CHARACTERS_BY_NAME = 'GET_CHARACTERS_BY_NAME';
export const FILTER_BY_VALUE = 'FILTER_BY_VALUE';
export const GET_INFO_CHARACTER = 'GET_INFO_CHARACTER';